import { useEffect, useRef } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface MoveDemandBookingConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onMoveThisBooking: () => void;
  onMoveAllFutureBookings: () => void;
}

export function MoveDemandBookingConfirmDialog({
  open,
  onCancel,
  onMoveThisBooking,
  onMoveAllFutureBookings,
}: MoveDemandBookingConfirmDialogProps) {
  const scopeSelectedRef = useRef(false);

  useEffect(() => {
    if (open) scopeSelectedRef.current = false;
  }, [open]);

  const handleOpenChange = (isOpen: boolean) => {
    if (isOpen) return;
    if (scopeSelectedRef.current) {
      scopeSelectedRef.current = false;
      return;
    }
    onCancel();
  };

  const handleScopeSelection = (onSelect: () => void) => {
    scopeSelectedRef.current = true;
    onSelect();
  };

  return (
    <AlertDialog open={open} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Move Open Demand Booking</AlertDialogTitle>
          <AlertDialogDescription>
            Do you want to move this booking only, or this and all future bookings linked to this accepted demand plan?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={() => handleScopeSelection(onMoveThisBooking)}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            This booking
          </AlertDialogAction>
          <AlertDialogAction
            onClick={() => handleScopeSelection(onMoveAllFutureBookings)}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            All future linked bookings
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
